import type { MeetingData, MeetingPayloadData } from '../../types';

import { AxiosError } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';

import { axiosClient } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';

type Payload = {
  companyID: number;
  meetingID: number;
  body: Partial<MeetingPayloadData>;
};

export const editMeeting = async ({ companyID, meetingID, body }: Payload): Promise<{ data: MeetingData }> => {
  const { data } = await axiosClient.put<{ data: MeetingData }>(`/companies/${companyID}/meetings/${meetingID}`, body);

  return data;
};
type UseEditMeetingOptions = {
  config?: Partial<UseMutationOptions<{ data: MeetingData }, AxiosError<{ message: string }>, Payload>>;
  postSuccess?: () => void;
};

export const useEditMeeting = ({ config, postSuccess }: UseEditMeetingOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.message,
      });
    },
    onSuccess: async (_, params) => {
      await queryClient.invalidateQueries({
        queryKey: ['meetings'],
      });
      await queryClient.invalidateQueries({
        queryKey: ['meeting-details', params.companyID, params.meetingID],
      });
      toaster.success({
        message: 'Updated Successfully',
        description: 'Meeting Updated Successfully',
      });
      postSuccess?.();
    },
    ...config,
    mutationFn: editMeeting,
  });
};
